import { motion } from "framer-motion"; // Importing motion from framer-motion
import { Skeleton } from "../ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
  tableTheme?: "default" | "gray";
}

export function TableSkeleton({
  rows = 5,
  columns = 4,
  showHeader = true,
  tableTheme = "default",
}: TableSkeletonProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }} // Start with 0 opacity
      animate={{ opacity: 1 }} // Animate to 1 opacity
      transition={{ duration: 1 }} // 1 second fade-in duration
    >
      <div className="w-full border rounded-[12px] BookEZ_table_border_color">
        <Table>
          {showHeader && (
            <TableHeader tableTheme={tableTheme}>
              <TableRow>
                {Array.from({ length: columns }).map((_, i) => (
                  <TableHead key={i} className="px-4 ">
                    {/* Adding motion.div for header skeleton */}
                    <motion.div
                      initial={{ opacity: 0 }} // Start with opacity 0 (invisible)
                      animate={{ opacity: 1 }} // Animate to opacity 1 (fully visible)
                      transition={{ duration: 0.5 }} // Transition duration of 0.5s
                    >
                      <Skeleton className="h-6 w-full max-w-[120px]" />
                    </motion.div>
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
          )}
          <TableBody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <TableRow
                key={rowIndex}
                className="BookEZ_table_border_color border-b last:border-b-0"
              >
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    {/* Adding motion.div for row skeleton */}
                    <motion.div
                      initial={{ opacity: 0 }} // Start with opacity 0 (invisible)
                      animate={{ opacity: 1 }} // Animate to opacity 1 (fully visible)
                      transition={{ duration: 0.5 }} // Transition duration of 0.5s
                    >
                      <Skeleton className="px-4 py-3 h-5 w-full" />
                    </motion.div>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </motion.div>
  );
}
